'use strict';

angular.module('atex.dam').directive('damEngagementList', ['ContentService','$state','$stateParams','$q','DamNotificationService','DamService','$window','$translate','configuration',
  function(ContentService,$state,$stateParams,$q,DamNotificationService,DamService,$window, $translate, configuration) {
    return {
      restrict : 'EA',
      templateUrl : 'views/dam-engagement-list.html',
      replace : false,
      scope : {
        engagement : "="
      },
      link : function(scope, element, attrs) {
        scope.entries = [];
        scope.ids = [];

        configuration.whenReady().then(function() {
          scope.adminGUIUrl = configuration.getAdminGUIUrl();
          scope.previewUrl = configuration.getPreviewUrl();
          scope.engagementLinks = configuration.getEngagementAppLinks();
        });

        DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
          scope.engagement.data.engagementList.forEach(function (engage) {
            var entry = {};

            entry.timestamp = engage.timestamp;
            entry.appType = engage.appType;
            entry.appPk = engage.appPk;
            entry.userName = engage.userName;
            entry.attributes = {};

            if (entry.appType === 'atex.dm.polopoly') {
              entry.firstPublish = engage.creationTimestamp;
            }

            var isAdmin = currentUserInfo.isAdm;
            engage.attributes.forEach(function (attribute) {
              // do not show engage attributes that start with 'x-' since they are for internal purposes
              // unless you are an admin so we can show them to easy debug.
              if (!attribute.name.startsWith('x-') || isAdmin) {
                entry.attributes[attribute.name] = attribute.value;
              }
            });

            scope.ids[engage.appPk] = entry;

            scope.entries.push(entry);
          });
        });

        scope.renderEntry = function(appType, entryId) {
          if (entryId.startsWith("onecms:") || entryId.startsWith("draft:")) {
            scope.listEntry(entryId);
          } else if (entryId.startsWith("policy:")) {
            scope.previewPolicyEntry(appType, entryId);
          } else {
            scope.previewOtherEntry(appType, entryId);
          }
        };

        scope.listEntry = function(onecmsId) {
          var engaged=[];
          ContentService.getContent({id :onecmsId}).then(function(entry) {
            entry._data = entry.data;
            entry.engage = scope.ids[entry.id];
            engaged.push(entry);

            $state.go('list.engagements', {'items' : engaged});
          });
        };

        scope.previewPolicyEntry = function(appType, value) {
          // policy content
          var contentId = atex.dam.AngularUtils.removePolicyPrefix(value);
          DamService.getGalleryUrl(contentId).then(function(galleryUrl) {
            var url = galleryUrl.data+"#device=window&width=840";
            $window.open(url, "_blank");
          });
        };

        scope.previewOtherEntry = function(appType, value) {
          var templateUrl = "";
          if (scope.engagementLinks.hasOwnProperty(appType)) {
            var engagementLink = scope.engagementLinks[appType];
            templateUrl = engagementLink.url;
          } else {
            templateUrl = scope.adminGUIUrl;
          }
          var url = scope.populatePreviewUrl(templateUrl, value.replace("ace:",""));
          $window.open(url, "_blank");
        };

        scope.populatePreviewUrl = function (templateUrl, value) {
          return templateUrl.replace("${preview-url}", scope.previewUrl)
            .replace("${admin-gui-url}", scope.adminGUIUrl)
            .replace("${value}", value);
        };
      }
    };
  }]);
